// extracted by mini-css-extract-plugin
export var modal = "_i6-0";